/**
 * Functions, types to convert geometry to GeoJSON and back
 * @module
 */
import { polyLine2Copy, polyLine2Reverse } from "./polyLine2";
import type { PolyLine2 } from "./polyLine2Types";

export type LinearRing = number[][];
export type Polygon = number[][][];

export function polyLine2ToGeoJsonLinearRing(polyline: PolyLine2, reverse = false): LinearRing {
  if (reverse) {
    polyLine2Reverse(polyLine2Copy(polyline));
  }
  const pts: LinearRing = [];
  for (let i = 0, l = polyline.length; i < l; i += 2) {
    pts.push([polyline[i], polyline[i + 1]]);
  }
  return pts;
}

//creates a single linear ring polygon without holes
export function polyLine2ToGeoJsonPolygon(polyline: PolyLine2): Polygon {
  const polylines: Polygon = [];
  polylines.push(polyLine2ToGeoJsonLinearRing(polyline, true));
  return polylines;
}

//geojson format uses opposite clock directions for polygons, so each ring is reversed
//https://tools.ietf.org/html/rfc7946#section-3.1.6
export function polygonToGeoJsonPolygon(polygon: PolyLine2[]): Polygon {
  return polygon.map((x) => polyLine2ToGeoJsonLinearRing(x, true));
}
